<template lang="pug">
  #QRCode.container-width
    .p-3.text-center(
      v-if="data"
    )
      .mb-3.mt-3
        ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
          :profileUrl="data.picture_url",
          :style="{ 'width': '80px', 'height': '80px' }"
        )
      div
      h5.mb-2 {{ data.chinese_last_name }} {{ data.chinese_first_name }}
      small.mb-2
        i.fas.fa-map-marker-alt.mr-2
        span {{ data.stores[0].title }}
      hr
      small.d-block.m-0 誠摯邀請您成為我的好友
      //vue-qr(
      //  v-if="data",
      //  :text="`${ bindSaRouter }`"
      //)
      img(:src="`https://chart.googleapis.com/chart?cht=qr&chl=${bindSaRouter}&chs=250x250`")
      small.d-block.m-0 請掃描 QR-code
      //- small.d-block.mb-3 尊享 {{ $companyName }} 專屬顧問服務
      .d-flex.justify-content-center.my-3
        b-button.px-3(
          variant="primary",
          @click="shareUrl()"
        )
          i.fas.fa-link.mr-2
          span 分享連結
      //- .underThanTwoStore(
      //-   v-if="data.stores.length <= 2"
      //- )
      //-   b-row(
      //-     :no-gutters="data.stores.length === 2"
      //-   )
      //-     b-col(
      //-       :cols="data.stores.length === 2 ? 6 : 12",
      //-       v-for="(store,index) in data.stores",
      //-       :key="store.id",
      //-       :class="{ 'text-right pr-1': data.stores.length === 2 && index === 0, 'text-left pl-1': data.stores.length === 2 && index === 1 }"
      //-     )
      //-       b-button(
      //-         variant="primary",
      //-         @click="changeQRCodeHandler(store)"
      //-       ) {{ store.store_dealer_title }}/{{ store.title }}
      //- .moreThanTwoStore
      //-   b-select(
      //-     v-if="data.stores.length > 2"
      //-     :option="stores",
      //-     v-model="nowSelectStore"
      //-   )
      //-     b-form-select-option(
      //-       v-for="(store,index) in data.stores",
      //-       :key="store",
      //-       :value="store"
      //-     ) {{ store.store_dealer_title }}/{{ store.title }}
</template>

<script>
import { mapState } from 'vuex';
import VueQr from 'vue-qr';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'QRCodeIndex',
  components: {
    ProfilePhotoSticker,
    VueQr
  },
  data() {
    return {
      nowSelectStore: null
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    // 取得個人資料
    vm.$store.dispatch('sa_qr_code/getProfileHandler')
      .then(() => {
        vm.nowSelectStore = vm.data.stores[0] ? vm.data.stores[0] : null;
        vm.$swal.close();
      });
  },
  methods: {
    changeQRCodeHandler(store) {
      const vm = this;
      if (store === vm.nowSelectStore) return;
      vm.nowSelectStore = store;
    },
    shareUrl() {
      const vm = this;
      window.location = `http://line.naver.jp/R/msg/text/?誠摯邀請您成為我的好友!%0D%0A${vm.bindSaRouter}`;
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.sa_qr_code.data
    }),
    bindSaRouter() {
      const vm = this;
      if (process.env.NODE_ENV === 'development') {
        return encodeURIComponent(`${process.env.VUE_APP_DOMAIN}:${process.env.VUE_APP_DEV_PORT}/member/bind-sa?sa_id=${ vm.data ? vm.data.id : null }&store_id=${ vm.nowSelectStore ? vm.nowSelectStore.id : null }`);
      }
      if (vm.data !== null && vm.nowSelectStore !== null) {
        return encodeURIComponent(`${process.env.VUE_APP_DOMAIN}/member/bind-sa?sa_id=${ vm.data.id ? vm.data.id : null }&store_id=${ vm.nowSelectStore.id ? vm.nowSelectStore.id : null }`);
      }

      return encodeURIComponent(`${process.env.VUE_APP_DOMAIN}/member/bind-sa`);
    }
  }
};
</script>

<style>

</style>
